<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <form class="start-register" @submit.prevent="getPhrase">
    <p>
      {{ $t("modals.login.registration_start_subtitle") }}
    </p>
    <div class="start-register-input">
      <label>Roblox User Name</label>
      <input
        :class="{ error: state.errors.username?.length }"
        v-model="state.fields.username"
        type="text"
        placeholder="Enter your roblox user name"
      />
      <div class="error-text" v-if="state.errors.username?.length">
        <i><DangerTriangle /></i>
        <p v-for="error in state.errors.username" :key="error">
          {{ error }}
        </p>
      </div>
    </div>
    <div class="check">
      <ToggleInput v-model="state.terms_and_policy" />
      <p>
        By checking this box you agree to our
        <TermsModalWithButton />
      </p>
    </div>
    <div class="actions">
      <Button
        :disabled="!state.terms_and_policy || authorizing"
        action="submit"
        type="primary"
        style="width: 100%; height: 52px"
      >
        Continue
      </Button>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import mixin from "../mixins"

export default defineComponent({
  name: "StartAuthorizeMobile",
  mixins: [mixin],
})
</script>

<style lang="scss" scoped>
.start-register {
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 24px;
  p {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.4px;
    color: rgba(255, 255, 255, 0.8);
    max-width: 436px;
  }
  .start-register-input {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 8px;
    input {
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.12);
      padding: 14px 16px;
      border-radius: 12px;
      color: white;
      width: calc(100% - 32px);
      outline: none;
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
    input.error {
      background: rgba(255, 0, 0, 0.08);
      border: 1px solid #ff0000;
      border-radius: 12px;
    }
    label {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: #ffffff;
    }
  }
  .check {
    display: flex;
    gap: 8px;
    align-items: center;
    p {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: start;
      letter-spacing: -0.4px;
      color: rgba(255, 255, 255, 0.6);
      max-width: 233px;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    p {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: -0.4px;
      background: linear-gradient(
        135deg,
        #00ffaa 0%,
        #4579f5 51.65%,
        #9c42f5 99.83%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      cursor: pointer;
    }
  }
}
</style>
